declare global {
	interface Window {
		env: EnvType;
	}
}
type EnvType = {
	VITE_API_URL: string;
	VITE_E2E_BASE_URL: string;
	VITE_ENVIRONMENT: string;
	VITE_GOOGLE_CLIENT_ID: string;
	VITE_STAFF_PORTAL_URL: string;
	VITE_AUTODESK_HUB_URL: string;
	VITE_OTEL_ENABLED?: string;
	VITE_OTEL_COLLECTOR_URL?: string;
	VITE_VERSION?: string;
	/** Kit Tracking redesign pilot (PTB-6559). Unset = pilot entry points off. */
	VITE_KT_PILOT_URL?: string;
};
export const env: EnvType = { ...import.meta.env, ...window.env };
